import React, { useEffect, useState } from 'react';
import {
  Button,
  Space,
  DatePicker,
  Table,
  Alert,
  ConfigProvider,
  Select,
  message,
  Input,
  Radio,
} from 'antd';
import { EmptyFileColor } from 'patternx-svg';
import type { DatePickerProps } from 'antd/es/date-picker';
import type { RadioChangeEvent } from 'antd';
import moment from 'moment';
import 'moment/locale/zh-cn';
import PtxEmpty from '@/components/ptx-empty';
import {
  getOpenBizType,
  getOpenClientType,
  getOpenFileType,
  downoadOpenApi,
  getOpenSlaTableInfo,
  getOpenSlaStatisticInfo,
} from '@/services/initial';
import './index.less';

moment.locale('zh-cn');

type searchParams = {
  startTime: string;
  endTime: string;
  bizTypes: string[];
  clientTypes: string[];
  fileTypes: string[];
  fileName: string;
  projectId: string;
  single: boolean | undefined;
  statisticalScope: string;
};

const Opening: React.FC<{}> = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [param, setParam] = useState<searchParams>({} as searchParams);
  const [data, setData] = useState<any>();
  const [fileInfo, setFileInfo] = useState({
    avgCost: 0,
    maxCost: 0,
    minCost: 0,
    successCnt: 0,
    totalRecord: 0,
    successRatio: '',
    successScopeMap: null as any,
  });
  const [bizTypes, setBizTypes] = useState<any[]>([]);
  const [clientType, setClientType] = useState<any[]>([]);
  const [fileType, setFileType] = useState<any[]>([]);
  const [fileNameValue, setFileNameValue] = useState<any>(undefined);
  const [projectId, setProjectId] = useState<any>(undefined);
  const [single, setSingle] = useState<boolean | undefined>();
  const [statisticalScope, setStatisticalScope] = useState<any>(undefined);
  const [page, setPage] = useState<number>(1); // 当前页码
  const [size, setSize] = useState<number>(10); // 每页显示数据数量
  const [total, setTotal] = useState<number>(0); // 总共数据量

  const columns: any = [
    {
      title: '序号',
      dataIndex: 'index',
      key: 'index',
      render: (text: any, record: any, index: number) => (
        <div style={{ width: 50 }}>{index + 1}</div>
      ),
    },
    {
      title: '业务线',
      dataIndex: 'bizType',
      key: 'bizType',
      render: (text: any) => <div style={{ width: 160 }}>{text}</div>,
    },
    {
      title: '开始时间',
      dataIndex: 'startTime',
      key: 'startTime',
      render: (text: any) => <div style={{ width: 160 }}>{text}</div>,
    },
    {
      title: '结束时间',
      dataIndex: 'endTime',
      key: 'endTime',
      render: (text: any) => <div style={{ width: 160 }}>{text || '-'}</div>,
    },
    {
      title: '耗时',
      dataIndex: 'openCost',
      key: 'openCost',
      render: (text: any) => <div style={{ width: 60 }}>{text || '-'}</div>,
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      render: (text: any) => <div style={{ width: 160 }}>{text || '-'}</div>,
    },
    {
      title: '文件名',
      dataIndex: 'fileName',
      key: 'fileName',
      render: (text: any) => <div style={{ width: 90 }}>{text || '-'}</div>,
    },
    {
      title: '文件数',
      dataIndex: 'fileCount',
      key: 'fileCount',
      render: (text: any) => <div style={{ width: 100 }}>{text || '-'}</div>,
    },
    {
      title: '文件类型',
      dataIndex: 'fileType',
      key: 'fileType',
      render: (text: any) => <div style={{ width: 100 }}>{text || '-'}</div>,
    },
    {
      title: '三角面片数',
      dataIndex: 'triangleFacesCnt',
      key: 'triangleFacesCnt',
      render: (text: any) => <div style={{ width: 100 }}>{text || '-'}</div>,
    },
    {
      title: '构件数',
      dataIndex: 'elementCnt',
      key: 'elementCnt',
      render: (text: any) => <div style={{ width: 100 }}>{text || '-'}</div>,
    },
    {
      title: '图纸数',
      dataIndex: 'sheetCnt',
      key: 'sheetCnt',
      render: (text: any) => <div style={{ width: 100 }}>{text || '-'}</div>,
    },
    {
      title: '用户',
      dataIndex: 'userName',
      key: 'userName',
      render: (text: any) => <div style={{ width: 160 }}>{text || '-'}</div>,
    },
    {
      title: '客户端类型',
      dataIndex: 'clientType',
      key: 'clientType',
      render: (text: any) => <div style={{ width: 160 }}>{text || '-'}</div>,
    },
    {
      title: '企业名称',
      dataIndex: 'enterpriseName',
      key: 'enterpriseName',
      render: (text: any) => <div style={{ width: 160 }}>{text || '-'}</div>,
    },
    {
      title: '项目名称',
      dataIndex: 'projectName',
      key: 'projectName',
      render: (text: any) => <div style={{ width: 160 }}>{text || '-'}</div>,
    },
    {
      title: '扣减时间',
      dataIndex: 'deductionTime',
      key: 'deductionTime',
      render: (text: any) => <div style={{ width: 160 }}>{text !== null ? `${text}秒` : '-'}</div>,
    },
    {
      title: '业务侧标识',
      dataIndex: 'bizId',
      key: 'bizId',
      render: (text: any) => <div style={{ width: 160 }}>{text || '-'}</div>,
    },
    {
      title: 'ueInstanceId',
      dataIndex: 'ueInstanceId',
      key: 'ueInstanceId',
      render: (text: any) => <div style={{ width: 160 }}>{text || '-'}</div>,
    },
    {
      title: '是否预加载标记',
      dataIndex: 'preloaded',
      key: 'preloaded',
      render: (text: any) => <div style={{ width: 160 }}>{text === true ? '是' : '否'}</div>,
    },
    {
      title: '匹配口令',
      dataIndex: 'matchToken',
      key: 'matchToken',
      render: (text: any) => <div style={{ width: 160 }}>{text || '-'}</div>,
    },
  ];

  const renderEmpty = () => {
    return <PtxEmpty isEmpty={true} describe="暂无数据" icon={<EmptyFileColor />} />;
  };

  // 获取table数据
  const getDatas = async (params?: {
    startTime?: string;
    endTime?: string;
    bizTypes?: string[];
    clientTypes?: string[];
    fileTypes?: string[];
    fileName?: string;
    projectId?: string;
    single?: boolean;
    statisticalScope?: string;
  }) => {
    setIsLoading(true);
    const res = await getOpenSlaTableInfo({
      startTime: params?.startTime === '' ? '' : params?.startTime || param?.startTime,
      endTime: params?.endTime === '' ? '' : params?.endTime || param?.endTime,
      bizTypes: params?.bizTypes || param?.bizTypes,
      clientTypes: params?.clientTypes || param?.clientTypes,
      fileTypes: params?.fileTypes || param?.fileTypes,
      fileName: params?.fileName === '' ? '' : params?.fileName || param?.fileName,
      projectId: params?.projectId === '' ? '' : params?.projectId || param?.projectId,
      single: params?.single === true || params?.single === false ? params?.single : param?.single,
      statisticalScope:
        params?.statisticalScope === '' ? '' : params?.statisticalScope || param?.statisticalScope,
      pageIndex: page,
      pageSize: size,
    });
    setIsLoading(false);
    if (res?.success) {
      if (res.data.current > res.data.pages) {
        // 当前页数超过实际可请求到的页数时的处理
        const resOnceMore = await getOpenSlaTableInfo({
          startTime: params?.startTime === '' ? '' : params?.startTime || param?.startTime,
          endTime: params?.endTime === '' ? '' : params?.endTime || param?.endTime,
          bizTypes: params?.bizTypes || param?.bizTypes,
          clientTypes: params?.clientTypes || param?.clientTypes,
          fileTypes: params?.fileTypes || param?.fileTypes,
          fileName: params?.fileName === '' ? '' : params?.fileName || param?.fileName,
          projectId: params?.projectId === '' ? '' : params?.projectId || param?.projectId,
          single:
            params?.single === true || params?.single === false ? params?.single : param?.single,
          statisticalScope:
            params?.statisticalScope === ''
              ? ''
              : params?.statisticalScope || param?.statisticalScope,
          pageIndex: res.data.pages,
          pageSize: size,
        });
        const datas = resOnceMore?.data?.records;
        setData(datas);
        setTotal(resOnceMore.data.total || 0);
        setPage(resOnceMore.data.current || 1);
        setSize(resOnceMore.data.size || 10);
        console.log('getOpeningDatas', res, resOnceMore);
      } else {
        const datas = res?.data?.records;
        setData(datas);
        setTotal(res.data.total || 0);
        setPage(res.data.current || 1);
        setSize(res.data.size || 10);
      }
    }
  };

  const getSlaOpenStatistics = async (params?: {
    startTime?: string;
    endTime?: string;
    bizTypes?: string[];
    clientTypes?: string[];
    fileTypes?: string[];
    fileName?: string;
    projectId?: string;
    single?: boolean;
    statisticalScope?: string;
  }) => {
    const res = await getOpenSlaStatisticInfo({
      startTime: params?.startTime === '' ? '' : params?.startTime || param?.startTime,
      endTime: params?.endTime === '' ? '' : params?.endTime || param?.endTime,
      bizTypes: params?.bizTypes || param?.bizTypes,
      clientTypes: params?.clientTypes || param?.clientTypes,
      fileTypes: params?.fileTypes || param?.fileTypes,
      fileName: params?.fileName === '' ? '' : params?.fileName || param?.fileName,
      projectId: params?.projectId === '' ? '' : params?.projectId || param?.projectId,
      single: params?.single === true || params?.single === false ? params?.single : param?.single,
      statisticalScope:
        params?.statisticalScope === '' ? '' : params?.statisticalScope || param?.statisticalScope,
    });
    console.log('getOpenSlaStatisticInfo', res);
    if (res.success) {
      const details = res?.data?.details;
      setFileInfo({
        avgCost: details?.avgCost,
        maxCost: details?.maxCost,
        minCost: details?.minCost,
        successCnt: details?.successCnt,
        totalRecord: details?.totalRecord,
        successRatio: details?.successRatio,
        successScopeMap: details?.successScopeMap,
      });
    }
  };

  // 获取业务线选项列表
  const getBizType = async () => {
    const res = await getOpenBizType();
    if (res?.success) {
      const data = res?.data?.details || [];
      setBizTypes(
        data.map((d: string) => {
          return {
            label: d,
            value: d,
          };
        }),
      );
    }
  };

  // 获取终端选项列表
  const getClientType = async () => {
    const res = await getOpenClientType();
    if (res?.success) {
      const data = res?.data?.details || [];
      setClientType(
        data.map((d: string) => {
          return {
            label: d,
            value: d,
          };
        }),
      );
    }
  };

  // 获取文件类型选项列表
  const getFileType = async () => {
    const res = await getOpenFileType();
    if (res?.success) {
      const data = res?.data?.details || [];
      setFileType(
        data.map((d: string) => {
          return {
            label: d,
            value: d,
          };
        }),
      );
    }
  };

  // 初始化
  const init = () => {
    getDatas(); // 获取table数据
    getBizType(); // 获取业务线选项列表
    getClientType(); // 获取终端选项列表
    getFileType(); // 获取文件类型选项列表
    getSlaOpenStatistics(); // 获取sla打开的统计数据
  };

  // 搜索-时间范围-起始时间
  const onChange1 = (value: DatePickerProps['value']) => {
    const startTime = value?.format('YYYY-MM-DD HH:mm:ss') || '';
    console.log(startTime, 'onChange1');
    setParam({
      ...param,
      startTime,
    });
    getDatas({
      ...param,
      startTime,
    });
    getSlaOpenStatistics({
      ...param,
      startTime,
    });
  };

  // 搜索-时间范围-截止时间
  const onChange2 = (value: DatePickerProps['value']) => {
    const endTime = value?.format('YYYY-MM-DD HH:mm:ss') || '';
    setParam({
      ...param,
      endTime,
    });
    getDatas({
      ...param,
      endTime,
    });
    getSlaOpenStatistics({
      ...param,
      endTime,
    });
  };

  // 搜索-业务线
  const handleChange1 = (value: string[]) => {
    setParam({
      ...param,
      bizTypes: value,
    });
    getDatas({
      bizTypes: value,
    });
    getSlaOpenStatistics({
      bizTypes: value,
    });
  };

  // 搜索-终端类型
  const handleChange2 = (value: string[]) => {
    setParam({
      ...param,
      clientTypes: value,
    });
    getDatas({
      clientTypes: value,
    });
    getSlaOpenStatistics({
      clientTypes: value,
    });
  };

  // 搜索-文件类型
  const handleChange3 = (value: string[]) => {
    setParam({
      ...param,
      fileTypes: value,
    });
    getDatas({
      fileTypes: value,
    });
    getSlaOpenStatistics({
      fileTypes: value,
    });
  };

  // 搜索-文件名称
  const handleFileNameChange = (e: any) => {
    const value = e.target.value;
    if (value) {
      setFileNameValue(value);
    } else {
      setFileNameValue(undefined);
      getDatas({
        // 搜索框内容全部删除时，重置table数据
        fileName: '',
      });
      getSlaOpenStatistics({
        fileName: '',
      });
    }
    setParam({
      ...param,
      fileName: value,
    });
  };

  // 搜索-项目id
  const handleProjectIdChange = (e: any) => {
    const value = e.target.value;
    if (value) {
      setProjectId(value);
    } else {
      setProjectId(undefined);
      getDatas({
        // 搜索框内容全部删除时，重置table数据
        projectId: '',
      });
      getSlaOpenStatistics({
        projectId: '',
      });
    }
    setParam({
      ...param,
      projectId: value,
    });
  };

  //指标范围
  const handleStatisticalScopeChange = (e: any) => {
    const value = e.target.value;
    if (value) {
      setStatisticalScope(value);
    } else {
      setStatisticalScope(undefined);
      getDatas({
        // 搜索框内容全部删除时，重置table数据
        statisticalScope: '',
      });
      getSlaOpenStatistics({
        statisticalScope: '',
      });
    }
    setParam({
      ...param,
      statisticalScope: value,
    });
  };

  // 搜索-确认搜索
  const onSearch = () => {
    getDatas();
    getSlaOpenStatistics();
  };

  //single
  const onChangeSingle = (e: RadioChangeEvent) => {
    const val = e.target.value;
    setSingle(val);
    setParam({
      ...param,
      single: val,
    });
    getDatas({
      // 搜索框内容全部删除时，重置table数据
      single: val,
    });
    getSlaOpenStatistics({
      single: val,
    });
  };

  // 当页码等相关参数的改变时，重新加载数据
  useEffect(() => {
    getDatas();
  }, [page, size]);

  useEffect(() => {
    init();
  }, []);

  const downoadAll = async () => {
    message.info('请稍等，正在导出文件');
    const res = await downoadOpenApi(param);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(new Blob([res!.data]));
    link.setAttribute('download', '打开SLA.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="sla-list-content">
      <div className="sla-list-search">
        <Space>
          <span>时间范围：</span>
          <DatePicker onChange={onChange1} showTime />
          <span>-</span>
          <DatePicker onChange={onChange2} showTime />
          <span>业务线：</span>
          <Select
            mode="multiple"
            style={{ width: 160 }}
            placeholder="请选择业务线"
            onChange={handleChange1}
            showArrow
            showSearch={false}
            options={bizTypes}
          />
          <span>终端类型：</span>
          <Select
            mode="multiple"
            style={{ width: 160 }}
            placeholder="请选择终端类型"
            onChange={handleChange2}
            showArrow
            showSearch={false}
            options={clientType}
          />
          <span>文件类型：</span>
          <Select
            mode="multiple"
            style={{ width: 160 }}
            placeholder="请选择文件类型"
            onChange={handleChange3}
            showArrow
            showSearch={false}
            options={fileType}
          />
        </Space>
        <Space style={{ marginTop: '12px' }}>
          <span>文件名称：</span>
          <Input
            style={{ width: 160 }}
            placeholder="请输入文件名称"
            onChange={handleFileNameChange}
            allowClear
            value={fileNameValue}
          />
          <span>项目id：</span>
          <Input
            style={{ width: 160 }}
            placeholder="请输入项目id"
            onChange={handleProjectIdChange}
            allowClear
            value={projectId}
          />
          <Radio.Group onChange={onChangeSingle} value={single}>
            <Radio value={true}>单个文件</Radio>
            <Radio value={false}>多个文件</Radio>
          </Radio.Group>
          <span>统计指标范围(秒)：</span>
          <Input
            style={{ minWidth: 150 }}
            placeholder="请输入统计指标范围"
            allowClear
            value={statisticalScope}
            onChange={handleStatisticalScopeChange}
          />
          <Button type="primary" ghost onClick={onSearch}>
            查询
          </Button>
          <Button onClick={downoadAll}>下载</Button>
        </Space>
        <Alert
          message={
            <>
              <div>
                正常打开统计，平均耗时：{fileInfo?.avgCost || 0}秒，最短耗时：
                {fileInfo?.minCost || 0}秒，最长耗时：{fileInfo?.maxCost || 0}秒
              </div>
              <div>
                成功总数：{fileInfo?.successCnt}，总数：{fileInfo?.totalRecord}，成功占比：
                {fileInfo?.successRatio}
              </div>
              {Object.keys(fileInfo.successScopeMap || {})?.map((k: any) => (
                <div>
                  {k}秒内, 范围数量：{fileInfo.successScopeMap[k]?.scopeCnt || 0}, 范围占比：
                  {fileInfo.successScopeMap[k]?.scopeRatio || '0%'}
                </div>
              ))}
            </>
          }
          type="info"
          style={{ padding: '4px 15px', marginTop: '12px' }}
        />
      </div>

      <div className="sla-list-table">
        <ConfigProvider renderEmpty={renderEmpty}>
          <Table
            rowKey={(record) => record.id}
            loading={isLoading}
            columns={columns}
            dataSource={data || []}
            // pagination={false}
            pagination={{
              position: ['bottomRight'],
              size: 'small',
              showTotal: (total, range) => {
                return `${range[0]}-${range[1]}条，共${total}条`;
              },
              showTitle: true,
              showQuickJumper: false,
              showSizeChanger: true,
              total: total, // 分页总数
              pageSize: size, // 每页数量
              current: page, // 当前页数
              onChange: (p, s) => {
                console.log('翻页', { p, s });
                setPage(p);
                setSize(s as number);
              },
            }}
            scroll={{ x: true, y: 'calc(100vh - 345px)' }}
          />
        </ConfigProvider>
      </div>
    </div>
  );
};

export default Opening;
